const apiPath = {
  trainingCertificationList: "/v1/hr/training-certifications",
  trainingAssignments: "/v1/hr/training-assignments",
  trainingAssignmentsALLEmployees: "/v1/hr/training-assignments/all-employee",
  loginUser: "/v1/admin/login",
  getLogs: "/v1/admin/logs",
  getUsers: "/v1/admin/user",
  createUser: "/v1/admin/user",
  updateUser: "/v1/admin/user",
  changeUserStatus: "/v1/admin/user/change-status",
  refreshToken: "/v1/user/refresh-token",
  seriesList: "/v1/user/match/series",
  matchList: "/v1/user/match/list",
  refreshAmount: "/v1/admin/refresh-amount",
  userProfile: "/v1/user/profile",
  userProfileUpdate: "/v1/user/profile-update",
  userEditStake: "/v1/user/edit-stake",
  userEditOneClickStake: "/v1/user/edit-one-click-stake",
  activityLogs: "/v1/user/activity-logs",
  transactionLogs: "/v1/user/transaction/logs",
  matchDetail: "/v1/user/match/detail",
  matchScore: "/v1/user/match/score",
  sportsList: "/v1/user/sport/list",
  inPlayCount: "/v1/user/sport/inplay-count",
  betfairPlaceBet: "/v1/user/match/betfaire-place-bet",
  soccerPlaceBet: "/v1/user/match/soccer-place-bet",
  tennisPlaceBet: "/v1/user/match/tennis-place-bet",
  userInPlaySport: "/v1/user/sport",
  bookmakerBet: "/v1/user/match/bookmaker-place-bet",
  betPosition: "/v1/user/match/get-bet-positions",
  betEventsBetPosition: "/v1/user/match/get-events-bet-positions",
  multiEventPlaceBet: "/v1/user/match/multiple-event-place-bet",
  getCurrentBetsExchanges: "/v1/user/match/my-bets",
  cancelUnmatchedBets: "/v1/user/match/clear-unmatched-bet",
  getBookmakerBets: "/v1/user/match/my-bookmaker-bets",
  getFancyBets: "/v1/user/match/my-fancy-bets",
  getSportsBook: "/v1/user/match/my-sport-book-bets",
  fancyBetPlace: "/v1/user/match/fancy-place-bet",
  multiMarket: "/v1/user/sport/multi-market",
  preminumFancyBets: "/v1/user/match/premium-fancy-place-bet",
  addMatchInMultiMarket: "/v1/user/sport/multi-market",
  getPremiumFancy: "/v1/cron/premium-fancy",
  getBetsData: "/v1/user/match/events-bets",
  getHistory: "/v1/user/match/bet-history",
  messageList: "/v1/user/message/list",
  userSubscribe: "/v1/user/subscribe",
  adminSetting: "/v1/user/site-setting/site-setting-list",
  getWalletTransactions: "/v1/admin/wallet-transaction",
  getTransactions: "/v1/admin/transaction",
  statususer: "/v1/admin/user/change-status",
  deleteSubAdmin: "/v1/admin/subadmin/delete",
  addMerchant: "/v1/admin/merchant",
  editMerchant: "/v1/admin/merchant",
  getMerchantList: "/v1/admin/merchant/list",
  deleteMerchant: "/v1/admin/merchant",
  changeMerchantStatus: "/v1/admin/merchant/status",
  updateSettings: "/v1/admin/setting",
  updateMcrSettings: "/v1/admin/mcr-settings",
  getMcrSettings: "/v1/admin/mcr-settings",
  changeMerchantVerified: "/v1/admin/merchant/verify",
  getFAQs: "/v1/admin/faqs",
  getContactUs: "/v1/admin/contact-us",
  changeFAQStatus: "/v1/admin/faqs/status",
  getStaticContent: "/v1/admin/static-content",
  deleteStaticContent: "/v1/admin/static-content/delete",
  changeContentStatus: "/v1/admin/static-content/change-status",
  forgotPassword: "/v1/admin/forgot-password",
  resetPassword: "/v1/admin/reset-password",
  changePassword: "/v1/admin/change-password",
  editProfile: "/v1/admin/edit-profile",
  getAllOffers: "/v1/admin/offers",
  getUserDetails: "/v1/admin/user/details",
  getDashboardDetails: "/v1/admin/dashboard",
  getTransactionGraphData: "/admin/transaction-graph",
  getTransactionAnalytics: "/admin/transaction-analytics",
  getReports: "/v1/admin/report",
  getAgents: "/v1/admin/merchant/agents",
  getMicroCreditLoanSlabs: "/v1/admin/micro-credit-loan-slabs",
  getMicroCreditLoanRequests: "/v1/admin/loans",
  ChangeStatusMicroCreditLoanRequests: "/v1/admin/loans/change-status",
  subcategoryList: "/v1/admin/subcategory",
  subcategory: "/v1/admin/subcategory",
  subCategoryStatus: "/v1/admin/subcategory/change-status",
  deleteSubCategory: "/v1/admin/subcategory",
  subcategoryAdd: "/v1/admin/subcategory",
  subcategoryUpdate: "/v1/admin/subcategory",
  categoryListList: "/v1/hr/document-category",
  orders: "/v1/admin/orders",
  changeOfferStatus: "/v1/admin/offers/change-status",
  getCompany: "/v1/admin/company",
  changeCompanyStatus: "/v1/admin/company/change-status",
  updateCompany: "/v1/admin/company",
  deleteCompany: "/v1/admin/company",
  editCompany: "/v1/admin/company",
  countryList: "/v1/admin/country",
  countryStatus: "/v1/admin/country/change-status",
  countryAdd: "/v1/admin/country",
  countryUpdate: "/v1/admin/country",
  stateList: "/v1/admin/state",
  stateStatus: "/v1/admin/state/change-status",
  stateAdd: "/v1/admin/state",
  stateUpdate: "/v1/admin/state",
  cityList: "/v1/admin/city",
  cityStatus: "/v1/admin/city/change-status",
  cityAdd: "/v1/admin/city",
  cityUpdate: "/v1/admin/city",
  getCountryList: "/v1/admin/country/list",
  getStateList: "/v1/admin/state/list",
  getStateListByCountry: "/v1/admin/state/list-by-country",
  getSupport: "/v1/admin/support",
  updateReply: "/v1/admin/support/reply",
  getSubscriptionList: "/v1/admin/subscription",
  subscriptionStatus: "/v1/admin/subscription/change-status",
  subscriptionAdd: "/v1/admin/subscription",
  subscriptionUpdate: "/v1/admin/subscription",
  subscriptionDelete: "/v1/admin/subscription",
  getsubadmin: "/v1/admin/subadmin/list",
  addSubadmin: "/v1/admin/subadmin/add",
  statusSub: "/v1/admin/subadmin/change-status",
  editSubadmin: "/v1/admin/subadmin/edit",
  getBanner: "/v1/admin/banner",
  changeBannerStatus: "/v1/admin/banner/change-status",
  createBanner: "/v1/admin/banner",
  updateBanner: "/v1/admin/banner",
  categoryAllList: "/v1/admin/category/list",
  getNotification: "/v1/admin/notifications",
  notificationAdd: "/v1/admin/notifications",
  notificationEdit: "/v1/admin/notifications",
  allCompany: "/v1/admin/company/all-companies",
  getRegisteredCompany: "/v1/admin/reports",
  downloadRegisteredCompany: "/v1/admin/reports/download",
  getSubscription: "/v1/admin/reports",
  getEarnings: "/v1/admin/earnings",
  deleteEarning: "/v1/admin/earnings/delete",
  CompanyChangePassword: "/v1/admin/company/change-password",
  getBellNotification: "/v1/admin/notifications/User-notifications-list",
  checkNotification: "/v1/admin/notifications/check-notification",
  companyList: "/v1/admin/company/generate-auth-token",
  getFormsManager: "/v1/hr/forms",
  getFormsManager: "/v1/admin/forms",

  getFormsById: "/v1/admin/forms/formById",
  changeFormsStatus: "/v1/admin/forms/status",
  getJobs: "/v1/admin/jobs/submitted-forms-list",
  changeJobsStatus: "/v1/admin/jobs/change-form-status",

  /// hr-related

  getSettings: "/v1/admin/setting",
  loginHR: "/v1/hr/login",
  forgotPasswordHR: "/v1/hr/forgot-password",
  resetPasswordHR: "/v1/hr/reset-password/hr-login",
  updateProfileHR: "/v1/hr/edit-profile",
  getCountryCityList: "/v1/user/master-data",
  changePasswordHR: "/v1/hr/change-password",
  finalEmployeeList: "/v1/hr/onboarded-employee-list",
  deleteJobRequest: "/v1/hr/job-request",
  allEmployeeList: "/v1/hr/all-employee",
  dischargeEmployee: "/v1/hr/jobRequests/discharge-employee",
  toggleEmployeeStatus: "/v1/hr/jobRequests/toggle-employee-status",
  employeeEmployementStatue: "/v1/hr/jobRequests/update-employment-status",
  getDashboardHRDetails: "/v1/hr/dashboard",
  hrLeaveList: "/v1/hr/leavesList",
  hrLeaveRequestList: "/v1/hr/emp-leave-request-list",
  submitFormByEmployee: "/v1/hr/submitted-forms-list",
  ChangeLeaveStatus: "/v1/hr/change-leave-status",
  changeFormStatus: "/v1/hr/change-form-status",
  departmentList: "/v1/hr/departmentList",
  loginAccountant: "/v1/accountant/login",
  updateProfileAccountant: "/v1/accountant/edit-profile",
  getDashboardAccountantDetails: "/v1/accountant/dashboard",
  forgotPasswordAccountant: "/v1/accountant/forgot-password",
  resetPasswordAccountant: "/v1/accountant/reset-password/accountant-login",
  changePasswordAccountant: "/v1/accountant/change-password",
  timeSheetList: "/v1/accountant/employees-timesheet",
  employeeList: "/v1/accountant/all-employee-list",
  downloadBiometric: "/v1/accountant/download-employeesTimeSheet",
  manageSalaryList: "/v1/accountant/list-employee-salary",
  updateSalary: "/v1/accountant/edit-employee-salary",
  deleteEmployeeSalary: "/v1/accountant/delete-employee-salary",
  finalAccountantEmployeeList: "/v1/accountant/onboarded-employee-list",
  createSalary: "/v1/accountant/create-employee-salary",
  listDepartment: "/v1/accountant/list-department-salary",
  generateSalaryList: "/v1/accountant/list-generate-salary",
  generateSalary: "/v1/accountant/generate-salary",
  updateGenerateSalary: "/v1/accountant/edit-generate-salary",
  markPaidSalary: "/v1/accountant/mark-paid",
  getDepartmentList: "/v1/accountant/department-list",
  downloadSlip: "/v1/accountant/download-slip",
  deleteGenerateSalary: "/v1/accountant/delete-generate-salary",
  timeSheetListHR: "/v1/hr/employees-timesheet",
  deleteTimeSheet: "/v1/hr/delete-timesheet",
  employeeListHR: "v1/Hr/all-employee-list",
  downloadBiometricHR: "v1/hr/download-employeesTimeSheet",
  accountantNotification: "v1/accountant/notification",
  HRNotification: "v1/hr/notification",
  checkHRNotification: "/v1/hr/check-notification",
  checkAccountantNotification: "/v1/accountant/check-notification",
  offerList: "/v1/hr/offer-letter-list",
  sendOffer: "/v1/hr/send-offer-letter",
  downloadoffer: "/v1/hr/download-offer-letter",


  downloadBiometricAccountant: "v1/accountant/download-employeesTimeSheet",
  // Background Check
  backgroundCandidatesList: "/v1/hr/background-verification/candidates",
  backgroundCheckInitiate: "/v1/hr/background-verification/initiate",
  backgroundCheck: "/v1/hr/background-verification",
  backgroundCheckTypes: "/v1/hr/background-verification/check-types",
  backgroundCheckRefresh: (id) => `/background-verification/${id}/refresh`,
  createBgCheckout: "/v1/hr/background-verification/create-checkout-session",
  verifyBgPayment: "/v1/hr/background-verification/verify-payment",
  getBackgroundCheckPrices: "/v1/admin/background-check-pricing/prices",
  
  hrCompletionStatus: "/v1/hr/hr-completion-status",
  accountantCompletionStatus: "/v1/accountant/accountant-completion-status",

  blog: `/v1/admin/blog`,
  changeBlogStatus: `/v1/admin/blog/change-status`,
  deleteBlog: `/v1/admin/blog/delete`,
  blogCategory: `/v1/admin/blog/category`,
  changeBlogCategoryStatus: `/v1/admin/blog/category/change-status`,
  deleteBlogCategory: `/v1/admin/blog/category/delete`,
  uploadImage: `/v1/admin/blog/upload-image`,

  // Video Management
  video: "/admin/video",
  changeVideoStatus: "/admin/video/change-status",
  deleteVideo: "/admin/video/delete",
  toggleFeaturedVideo: "/admin/video/toggle-featured",

  // Mail Manager
  mailManagerList: "/v1/hr/employee-list-for-notification",
  createNotification: "/v1/hr/create-notification",
  documentList: "/v1/hr/documents",
  documentAdd: "/v1/hr/documents",
  documentUpdate: "/v1/hr/documents",
  documentStatus: "/v1/hr/documents/change-status",
  documentDelete: "/v1/hr/documents",

  categoryAdd: "/v1/hr/document-category",
  categoryList: "/v1/hr/documents",
  categoryUpdate: "/v1/hr/document-category",
  categoryStatus: "/v1/hr/document-category/change-status",
  categoryDelete: "/v1/hr/document-category",
  categoryList: "/v1/hr/document-category",
  AddCategory: "/v1/hr/document-category",
  categoryList: "/v1/hr/document-category",

  adminCategoryAdd: "/v1/admin/category",
  adminCategoryList: "/v1/admin/category",
  adminCategory: "/v1/admin/category",
  adminCategoryUpdate: "/v1/admin/category",
  adminCategoryStatus: "/v1/admin/category/change-status",

  aremployeeListHR: "v1/hr/attendance-report/all-employee-list",
  weeklyTimeSheetListHR: "v1/hr/attendance-report/weekly-employees-timesheet",
  // Payroll
  payrollStatus: "/v1/hr/payroll/status",
  payrollList: "/v1/hr/payroll/list",
  payrollView: "/v1/hr/payroll/view",
  payrollGenerate: "/v1/hr/payroll/generate",
  payrollProcess: "/v1/hr/payroll/process",
  payrollDelete: "/v1/hr/payroll/delete",
  payrollEdit: "/v1/hr/payroll/edit",
  employeeWage: "/v1/hr/employee/wage",
  updateEmployeeWage: "/v1/hr/employee/wage",
  reportScheduledVsActual: "/v1/hr/reports/scheduled-vs-actual",
  reportLaborCost: "/v1/hr/reports/labor-cost",
  reportAttendancePunctuality: "/v1/hr/reports/attendance-punctuality",
  reportOvertime: "/v1/hr/reports/overtime",
  reportEmployeeHours: "/v1/hr/reports/employee-hours",
  downloadReport: "/v1/hr/reports/download",
  employeeSyncList: "/v1/hr/payroll/employees/sync-status",
  getLocations: "/v1/user/shift/location",
  employeeSync: "/v1/hr/payroll/employees",
  timesheetPendingSync: "/v1/hr/payroll/timesheets/pending-sync",
  timesheetSync: "/v1/hr/payroll/timesheets/sync",
  payrollSyncFromEveree: "/v1/hr/payroll/sync-from-everee",
  payrollTriggerPayout: "/v1/hr/payroll/trigger-payout",

  auditLogs: "/v1/admin/audit-logs",

  // Authenticated MFA management
  mfaStatus: "/v1/mfa/status",
  mfaSetupInitiate: "/v1/mfa/setup/initiate",
  mfaSetupVerify: "/v1/mfa/setup/verify",
  mfaVerify: "/v1/mfa/verify",
  mfaVerifyRecoveryCode: "/v1/mfa/verify-recovery-code",
  mfaRecoveryCodesRegenerate: "/v1/mfa/recovery-codes/regenerate",
  mfaDisable: "/v1/mfa/disable",

  // Unauthenticated login step-up
  mfaLoginVerify: "/v1/mfa/login/verify",
  mfaLoginSetupVerify: "/v1/mfa/login/setup-verify",
  getBackgroundCheckPricing: "/v1/admin/background-check-pricing",
  changeBackgroundCheckPricingStatus: "/v1/admin/background-check-pricing/status",
  getAdminBusinessIntelligence: "/v1/admin/business-intelligence",

  geoAccessPolicy: "/v1/admin/geo-access/policy",
  geoAccessLogs: "/v1/admin/geo-access/logs",
  geoAccessEmployeeLocations: "/v1/admin/geo-access/employee-locations",
  hrGeoPolicy: "/v1/hr/geo-access/policy",
  hrGeoOffices: "/v1/hr/geo-access/offices",
  hrGeoLogs: "/v1/hr/geo-access/logs",
  hrGeoEmployeeIps: "/v1/hr/geo-access/employee",
  getPartnerInquiries: "/v1/admin/partner-inquiry",
  accountantEmployeeWage: "/v1/accountant/employee/wage",
  accountantUpdateEmployeeWage: "/v1/accountant/employee/wage",
};

export default apiPath;
